import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import categoriesService from '../api/categories.service';

function requestCategories(): IAction {
    return { type: types.CAT_ARTICLES_REQUESTED };
}

function categoriesReceived(category: string, articles): IAction {
    return { type: types.CAT_ARTICLES_RETRIEVED, data: { items: articles, category } };
}

function categoriesFailed(error): IAction {
    return { type: types.CAT_ARTICLES_FAILED, data: error };
}

function getCategories(category: string) {
    return dispatch => {
        dispatch(requestCategories());

        categoriesService.getArticlesForCategory(category).then(articles => {
            dispatch(categoriesReceived(category, articles));
            dispatch(changePage(1));
        }, err => {
            dispatch(categoriesFailed(err));
        });
    }
}

function shouldFetchCategoryArticles(state, category: string) {
    const categories = state.categoryArticles;

    if (categories.isFetching) {
        return false;
    }
    else if (typeof categories[category] === 'undefined') {
        return true;
    }
    else {
        return categories.loaded === false;
    }
}

export function changePage(page: number): IAction {
    return { type: types.CAT_ARTICLES_CHANGE_PAGE, data: page };
}

export function getCategoryArticlesIfNeeded(category: string) {
    return (dispatch, getState) => {
        if (shouldFetchCategoryArticles(getState(), category)) {
            return dispatch(getCategories(category));
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/category-articles.action.ts